<template>
  <v-app>
    <v-app-bar color="primary" flat app dark>
      <v-spacer></v-spacer>
      <v-app-bar-title style="min-width: fit-content;">アルバム一覧</v-app-bar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <v-container class="pa-2">
        <v-row>
          <v-btn block variant="text" color="primary" size="large" @click="() => isCreateDialogOpen = true">+
            アルバムを追加する</v-btn>
        </v-row>
        <v-progress-linear indeterminate color="primary" height="3" v-if="isFetching"></v-progress-linear>
        <v-tabs fixed-tabs v-model="listType" color="primary" class="mt-2">
          <v-tab>すべて</v-tab>
          <v-tab>公開中</v-tab>
          <v-tab>非公開中</v-tab>
        </v-tabs>
        <div>
          <!-- <template
            v-for="(album, i) in albums"
          >
            <v-list-item
              :to="`/album/${album.albumId}`"
            >
              <v-list-item-content>
                <v-list-item-title>{{ album.title }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider />
          </template> -->
          <template v-for="(album) in albums" :key="album.albumId">
            <v-list-item :to="`/album/${album.albumId}`" style="margin:8px;">
              <v-list-item-title>{{ album.title }}</v-list-item-title>

              <template #append>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-list-item>

            <v-divider />
          </template>
        </div>
        <v-row class="my-2" v-if="hasMoreAlbums">
          <v-btn block text color="primary" large @click="loadMore">さらに読み込む</v-btn>
        </v-row>
      </v-container>
    </v-main>

    <v-dialog v-model="isCreateDialogOpen" max-width="720">
      <v-card>
        <v-card-title class="align-center justify-center">
          アルバムを作成
        </v-card-title>
        <v-card-text>
          <div class="my-3">
            <span class="mb-2">年度</span>
            <v-text-field type="number" density="compact" hide-details variant="outlined" v-model="newAlbumYear"
              color="primary" :disabled="newAlbumClassIds && newAlbumClassIds.length > 0" />
          </div>
          <div class="my-3">
            <span class="mb-2">クラス</span>
            <v-select variant="outlined" multiple density="compact" hide-details v-model="newAlbumClassIds"
              :items="classes" item-value="classId" item-title="className" color="primary"></v-select>
          </div>
          <div class="my-3">
            <span class="mb-2">アルバムのタイトル</span>
            <v-text-field density="compact" hide-details variant="outlined" v-model="newAlbumTitle" color="primary" />
          </div>
          <div class="my-3">
            <span class="mb-2">コメント</span>
            <v-text-field density="compact" hide-details variant="outlined" v-model="newAlbumComment" color="primary" />
          </div>
          <div class="my-3">
            <v-radio-group v-model="albumType" inline color="primary">
              <v-radio label="日常" value="ordinary"></v-radio>
              <v-radio label="行事" value="event"></v-radio>
              <v-radio label="その他" value="undefined"></v-radio>
            </v-radio-group>
          </div>
          <div>
            <v-col cols="12" v-if="albumType === 'ordinary' || albumType === 'event'">
              <v-select v-model="selectedMonth" :items="monthItems" item-title="title" item-value="value"
                label="月を選択" hide-details variant="outlined" density="compact" color="primary">
              </v-select>
            </v-col>
          </div>
          <div class="my-3" v-if="!isCreateInClosed">
            <div class="d-flex align-center">
              <span class="mb-2">公開開始日 *</span>
              <v-spacer />
              <v-checkbox :label="`すぐに公開`" v-model="isPublishNow" color="primary" :disabled="albumType === 'ordinary' || albumType === 'event'"></v-checkbox>
            </div>
            <v-text-field v-if="!isPublishNow" type="datetime-local" density="compact" hide-details variant="outlined"
              v-model="newAlbumAvailableAfter" color="primary" :disabled="albumType === 'ordinary' || albumType === 'event'"/>
          </div>
          <div class="my-3" v-if="!isCreateInClosed">
            <div class="d-flex align-center">
              <span class="mb-2">公開終了日</span>
              <v-spacer />
              <v-checkbox :label="`制限なし`" v-model="isPublicForever" color="primary" :disabled="albumType === 'ordinary' || albumType === 'event'"></v-checkbox>
            </div>
            <v-text-field v-if="!isPublicForever" type="datetime-local" density="compact" hide-details
              variant="outlined" v-model="newAlbumAvailableBefore" color="primary" :disabled="albumType === 'ordinary' || albumType === 'event'" />
          </div>

          <div class="my-2">
            <v-checkbox :label="`非公開で作成する`" v-model="isCreateInClosed" color="primary" :disabled="albumType === 'ordinary' || albumType === 'event'"></v-checkbox>
          </div>
        </v-card-text>
        <v-progress-linear indeterminate color="primary" height="3" v-if="isCreating"></v-progress-linear>
        <v-card-actions>
          <v-btn @click="() => isCreateDialogOpen = false">
            キャンセル
          </v-btn>
          <v-spacer />
          <v-btn color="primary" :disabled="isCreating || !availableAfterValue || !newAlbumTitle" @click="create" variant="flat">
            作成
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";

import { PostMeRequest } from '@/model/Request';
import { memoruAlbumsModule } from '@/store/dataModules/memoruAlbumsModule';
import { auth0Module } from '@/store/dataModules/auth0Module';
import LocalDataService from '@/service/LocalDataService';
import { MeNurserySchoolResponse, MultimediaAlbumResponse } from 'chaild-api/lib';
import dayjs from 'dayjs';
import ApiMemoru from '@/api/ApiMemoru';
import { nurseryModule } from '@/store/dataModules/nurseryModule';

interface DataType {
  isCreateDialogOpen: boolean;
  newAlbumYear: number;
  newAlbumTitle: string;
  newAlbumClassIds: Array<string | number>;
  newAlbumComment: string;
  newAlbumAvailableAfter: string | null;
  isPublishNow: boolean;
  newAlbumAvailableBefore: string | null;
  isPublicForever: boolean;
  isCreateInClosed: boolean;
  nurseryId: number | null;
  isCreating: boolean;
  isFetching: boolean;
  listType: number;
  albumType: 'ordinary' | 'event' | undefined;
  selectedMonth: number | undefined;
  monthItems: Array<{ title: string, value: number }>;
  monthlySchedules: Record<'ordinary' | 'event', Record<number, { afterDate: string; afterTime: string; beforeDate: string; beforeTime: string }>>;
}

export default defineComponent({
  computed: {
    albums(): MultimediaAlbumResponse[] {
      const albums = memoruAlbumsModule.albums

      if (this.listType === 1) {
        return this.publishedAlbums
      }

      if (this.listType === 2) {
        return this.unpublishedAlbums
      }

      return albums
    },
    allAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums
    },
    publishedAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums.filter((album) => {
        const diff1 = dayjs().diff(dayjs(album.availableAfter), 'day')
        if (album.availableBefore) {
          const diff2 = dayjs().diff(dayjs(album.availableBefore), 'day')
          return diff1 >= 0 && diff2 < 0
        }
        return diff1 >= 0;
      })
    },
    unpublishedAlbums(): MultimediaAlbumResponse[] {
      return memoruAlbumsModule.albums.filter((album) => {
        const diff1 = dayjs().diff(dayjs(album.availableAfter), 'day')
        if (album.availableBefore) {
          const diff2 = dayjs().diff(dayjs(album.availableBefore), 'day')
          return diff1 < 0 || diff2 >= 0
        }
        return diff1 < 0;
      })
    },
    hasMoreAlbums(): boolean {
      if (this.albums.length < memoruAlbumsModule.total) {
        return true;
      }
      return false;
    },
    classes() {
      return nurseryModule.allClasses as readonly any[] | undefined;
    },
    availableAfterValue() {
      if (this.isCreateInClosed || this.isPublishNow) {
        return dayjs().toISOString();
      }
      return this.newAlbumAvailableAfter
    },
    availableBeforeValue() {
      if (this.isCreateInClosed) {
        return dayjs().toISOString();
      }
      if (this.isPublicForever) {
        return null
      }
      return this.newAlbumAvailableBefore
    }
  },
  data: (): DataType => {
    return {
      isCreateDialogOpen: false,
      newAlbumYear: dayjs().year(),
      newAlbumTitle: '',
      newAlbumClassIds: [],
      newAlbumComment: '',
      newAlbumAvailableBefore: null,
      newAlbumAvailableAfter: null,
      isPublishNow: false,
      isPublicForever: false,
      isCreateInClosed: false,
      nurseryId: null,
      isCreating: false,
      isFetching: false,
      listType: 0,
      albumType: 'ordinary',
      selectedMonth: undefined,
      monthItems: [
        { title: '4月', value: 4 },
        { title: '5月', value: 5 },
        { title: '6月', value: 6 },
        { title: '7月', value: 7 },
        { title: '8月', value: 8 },
        { title: '9月', value: 9 },
        { title: '10月', value: 10 },
        { title: '11月', value: 11 },
        { title: '12月', value: 12 },
        { title: '1月', value: 1 },
        { title: '2月', value: 2 },
        { title: '3月', value: 3 },
      ],
      //今後のキャンペーンの動向確定後、DB管理に移行予定
      monthlySchedules: {
        ordinary: {
          1: { afterDate: '01-01', afterTime: '00:00', beforeDate: '01-28', beforeTime: '23:59' },
          2: { afterDate: '02-01', afterTime: '00:00', beforeDate: '02-25', beforeTime: '23:59' },
          3: { afterDate: '03-01', afterTime: '00:00', beforeDate: '03-25', beforeTime: '23:59' },
          4: { afterDate: '04-01', afterTime: '00:00', beforeDate: '04-23', beforeTime: '23:59' },
          5: { afterDate: '05-01', afterTime: '00:00', beforeDate: '05-28', beforeTime: '23:59' },
          6: { afterDate: '06-01', afterTime: '00:00', beforeDate: '06-25', beforeTime: '23:59' },
          7: { afterDate: '07-01', afterTime: '00:00', beforeDate: '07-23', beforeTime: '23:59' },
          8: { afterDate: '08-01', afterTime: '00:00', beforeDate: '08-27', beforeTime: '23:59' },
          9: { afterDate: '09-01', afterTime: '00:00', beforeDate: '09-24', beforeTime: '23:59' },
          10: { afterDate: '10-01', afterTime: '00:00', beforeDate: '10-29', beforeTime: '23:59' },
          11: { afterDate: '11-02', afterTime: '00:00', beforeDate: '11-26', beforeTime: '23:59' },
          12: { afterDate: '12-01', afterTime: '00:00', beforeDate: '12-24', beforeTime: '23:59' },
        },
        event: {
          1: { afterDate: '01-29', afterTime: '00:00', beforeDate: '02-25', beforeTime: '23:59' },
          2: { afterDate: '02-26', afterTime: '00:00', beforeDate: '03-25', beforeTime: '23:59' },
          3: { afterDate: '03-26', afterTime: '00:00', beforeDate: '04-22', beforeTime: '23:59' },
          4: { afterDate: '04-24', afterTime: '00:00', beforeDate: '05-28', beforeTime: '23:59' },
          5: { afterDate: '05-29', afterTime: '00:00', beforeDate: '06-25', beforeTime: '23:59' },
          6: { afterDate: '06-26', afterTime: '00:00', beforeDate: '07-23', beforeTime: '23:59' },
          7: { afterDate: '07-24', afterTime: '00:00', beforeDate: '08-27', beforeTime: '23:59' },
          8: { afterDate: '08-28', afterTime: '00:00', beforeDate: '09-24', beforeTime: '23:59' },
          9: { afterDate: '09-25', afterTime: '00:00', beforeDate: '10-29', beforeTime: '23:59' },
          10: { afterDate: '10-30', afterTime: '00:00', beforeDate: '11-26', beforeTime: '23:59' },
          11: { afterDate: '11-27', afterTime: '00:00', beforeDate: '12-24', beforeTime: '23:59' },
          12: { afterDate: '12-25', afterTime: '00:00', beforeDate: '01-28', beforeTime: '23:59' },
        },
      }
    }
  },
  methods: {
    async create() {
      if (this.nurseryId && this.availableAfterValue) {
        this.isCreating = true;
        const response = await ApiMemoru.createAlbum({
          nurseryId: this.nurseryId,
          year: this.newAlbumYear,
          title: this.newAlbumTitle,
          comment: this.newAlbumComment,
          nurseryClassIds: this.newAlbumClassIds,
          availableAfter: this.availableAfterValue,
          availableBefore: this.availableBeforeValue
        })
        this.isCreating = false;
        this.isCreateDialogOpen = false;

        memoruAlbumsModule.listAlbums(this.nurseryId);
        
        this.albumType = undefined;
        this.selectedMonth = undefined;
      }
    },
    clearCreateValues() {
      this.newAlbumTitle = '';
      this.newAlbumClassIds = [];
      this.newAlbumComment = '';
      this.newAlbumAvailableAfter = null;
      this.newAlbumAvailableBefore = null;
    },
    getClasses() {
      if (this.nurseryId && this.newAlbumYear) {
        nurseryModule.getNurseryClassWithYear({
          nurseryId: this.nurseryId,
          year: this.newAlbumYear
        })
      }
    },
    loadMore() {
      if (this.nurseryId) {
        memoruAlbumsModule.listMoreAlbums(this.nurseryId);
      }
    },
    applyMonthlySchedule() {
      if (!this.albumType || !this.selectedMonth) return;
      const schedule = this.monthlySchedules[this.albumType]?.[this.selectedMonth];
      if (!schedule) return;
      let year = this.newAlbumYear || String(new Date().getFullYear());
      year = this.selectedMonth <= 3 ? String(Number(year) + 1) : year;
      this.newAlbumAvailableAfter = `${year}-${schedule.afterDate} ${schedule.afterTime}`;
      if (this.selectedMonth === 12 && this.albumType === 'event') {
        this.newAlbumAvailableBefore = `${String(Number(year) + 1) }-${schedule.beforeDate} ${schedule.beforeTime}`;
      } else {
        this.newAlbumAvailableBefore = `${year}-${schedule.beforeDate} ${schedule.beforeTime}`;
      }
    },
  },
  async mounted() {
    const currentMonth = dayjs().month() + 1;
    if (currentMonth < 4) {
      this.newAlbumYear -= 1;
    }
    const user = LocalDataService.getUser();
    if (user) {
      let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
      if (!nurserySchool) {
        nurserySchool = user.nurserySchools[0];
      }
      const nurseryId = nurserySchool.nurseryId;
      this.nurseryId = nurseryId;
      this.isFetching = true;
      await Promise.all([
        memoruAlbumsModule.listAlbums(nurseryId),
        this.getClasses()
      ])
      this.isFetching = false;
    }
  },
  watch: {
    newAlbumYear() {
      this.getClasses();
    },
    albumType(newType: 'ordinary' | 'event' | undefined) {
      this.selectedMonth = undefined;
      if (newType === 'ordinary' || newType === 'event') {
        this.newAlbumAvailableAfter = '';
        this.newAlbumAvailableBefore = '';
      }
    },
    selectedMonth(newMonth: number | undefined) {
      if (newMonth && (this.albumType === 'ordinary' || this.albumType === 'event')) {
        this.applyMonthlySchedule();
      }
    },
  }
});
</script>
<style lang="scss" scoped></style>
